module.exports = __webpack_public_path__ + "src/assets/img/51.fe615fc0.svg";